import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";

/**
 * How article sources are shown:
 * - "legacy":   old unverified "Kaynakça ve Atıf" list (pre-Paket 2 live state only)
 * - "approved": only editor-approved sources (post_sources)
 * - "hidden":   no source sections and no citation at all (rollback; records stay intact)
 * Rollback must use "hidden", never "legacy": the old lists are unverified.
 */
export type SourcesMode = "legacy" | "approved" | "hidden";

/** Live-site mode. Preview always uses "approved" unless the live mode is "hidden". */
export const LIVE_SOURCES_MODE: SourcesMode = "approved";

export function isPreviewHostname(host?: string | null): boolean {
  const h = (host ?? "").toLowerCase().split(":")[0];
  return h === "localhost" || h === "127.0.0.1" || h.startsWith("id-preview--") || h.endsWith(".lovableproject.com");
}

export function resolveSourcesMode(live: SourcesMode, preview: boolean): SourcesMode {
  if (live === "hidden") return "hidden";
  return preview ? "approved" : live;
}

export const sourcesMode = createIsomorphicFn()
  .server((): SourcesMode => {
    let preview = false;
    try { preview = isPreviewHostname(new URL(getRequest().url).hostname); } catch { preview = false; }
    return resolveSourcesMode(LIVE_SOURCES_MODE, preview);
  })
  .client((): SourcesMode => resolveSourcesMode(LIVE_SOURCES_MODE, isPreviewHostname(window.location.hostname)));
